import React from 'react';
import classNames from 'classnames';
import styles from './NoData.module.scss';

type NoDataProps = {
    className?: string;
    text?: string;
    subText?: string;
    footerContent?: React.ReactNode;
    image?: string;
    height?: string;
};
const NoData = (props: NoDataProps) => {
    const { text = 'No Data', subText, image, height = '75vh', footerContent } = props;
    return (
        <div className={classNames(styles.noDataContainer, props.className)} style={{ height: height }} data-testid='no-data-container'>
            {image && <img src={image} alt='No data' className={styles.noDataImage} />}
            {text && <h3 className={styles.noDataTextContainer}>{text}</h3>}
            {subText && <p className={styles.noDataTextContainer}>{subText}</p>}
            {footerContent}
        </div>
    );
};

export default NoData;
